import React from 'react';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';

import ContentContainer from '../../components/content-container/content-container';
import Image from '../../components/image/image';
import Layout from '../../components/layout/layout';
import RichText, { Theme } from '../../components/rich-text/rich-text';

import type { ArticlePage as Props } from './article-page.types';

const ArticlePage: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  body,
  image,
  introduction,
  layout,
  published,
  title,
}) => (
  <Layout {...layout}>
    <div className="article-page">
      {image ? (
        <div className="article-page__image">
          <Image {...image} aspectRatio={Image.aspectRatios.Fill} />
        </div>
      ) : null}
      <ContentContainer width={ContentContainer.widths.Large}>
        <div className="article-page__title">
          <Text
            elementName="h1"
            size={Text.sizes.header2}
            variant={Text.variants.hero}
          >
            {title}
          </Text>
        </div>
        <div className="article-page__content">
          {introduction ? (
            <RichText
              className="article-page__introduction"
              theme={Theme.Intro}
              {...introduction}
            />
          ) : null}
          {published ? (
            <div className="article-page__published">
              <Text>{published}</Text>
            </div>
          ) : null}
          <RichText
            className="article-page__body"
            childClassNames={{ image: 'article-page__body-image' }}
            {...body}
          />
        </div>
      </ContentContainer>
    </div>
  </Layout>
);

export default ArticlePage;
